<template>
  <div class="flex gap-4 overflow-x-hidden px-5">
    <slot v-for="index in count" :key="index" :index="index - 1" />
  </div>
</template>

<script setup lang="ts">
const _props = withDefaults(
  defineProps<{
    count?: number;
  }>(),
  {
    count: 3, // Default to showing 3 skeleton cards
  },
);
</script>
